import { render, staticRenderFns } from "./ClueProtect.vue?vue&type=template&id=5a7fcfc7&"
import script from "./ClueProtect.vue?vue&type=script&lang=js&"
export * from "./ClueProtect.vue?vue&type=script&lang=js&"
import style0 from "./ClueProtect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports